import { Injectable } from '@angular/core';

@Injectable()
export class StoreLocatorCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello Store Location");
	}
}



// WEBPACK FOOTER //
// ./src/modules/store-locator/pages/store-locator/store-locator.common.ts